import React from "react";
import { Image } from 'semantic-ui-react';
import setColor from './../../common/SetColor';
import defaultUserAvatar from '../../../images/common/user-avatar.png'
class ImageAvater extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {
        let setImage;
        if (this.props.profilePic) {
            if (this.props.hoverComponent) {
                return this.props.hoverComponent(<Image
                    style={{ boxShadow: "0 0 5px -4px #333", width: "24px", height: "24px", margin: "0", background: "#fff" }}
                    floated='left'
                    size='mini'
                    src={this.props.profilePic}
                    onClick={this.props.onClick}
                    avatar
                    className={this.props.imageStyle ? this.props.imageStyle : null}
                />, this.props.user)
            } else {
                setImage = <Image
                    style={{ boxShadow: "0 0 5px -4px #333", width: "24px", height: "24px", margin: "0", background: "#fff" }}
                    floated='left'
                    size='mini'
                    src={this.props.profilePic}
                    onClick={this.props.onClick}
                    avatar
                    className={this.props.imageStyle ? this.props.imageStyle : null}
                />
            }

        }
        else if (this.props.user && this.props.user.profilePic) {
            if (this.props.hoverComponent) {
                return this.props.hoverComponent(<Image
                    style={{ boxShadow: "0 0 5px -4px #333", width: "24px", height: "24px", margin: "0", background: "#fff" }}
                    floated='left'
                    size='mini'
                    src={this.props.user.profilePic}
                    onClick={this.props.onClick}
                    avatar
                    className={this.props.imageStyle ? this.props.imageStyle : null}
                />, this.props.user)
            }
            else {
                setImage = <Image
                    style={{ boxShadow: "0 0 5px -4px #333", width: "24px", height: "24px", margin: "0", background: "#fff" }}
                    floated='left'
                    size='mini'
                    src={this.props.user.profilePic}
                    onClick={this.props.onClick}
                    avatar
                    className={this.props.imageStyle ? this.props.imageStyle : null}
                />
            }

        } else {
            if (this.props.hoverComponent) {
                return this.props.hoverComponent(this.props.user && this.props.user.firstName && this.props.user.lastName ?
                    <span
                        className={`avaterNameIcon ${this.props.className ? this.props.className : null}`}
                        style={{ background: setColor(this.props.user.firstName.charAt(0).toUpperCase()), width: "24px", height: "24px" }} onClick={this.props.onClick}>
                        {this.props.user.firstName.charAt(0).toUpperCase()}
                        {this.props.user.lastName.charAt(0).toUpperCase()}
                    </span> :
                    <Image
                        style={{ boxShadow: "0 0 5px -4px #333", width: "24px", height: "24px", margin: "0", background: "#fff" }}
                        floated='left'
                        size='mini'
                        src={defaultUserAvatar}
                        avatar
                        className={this.props.imageStyle ? this.props.imageStyle : null}
                    />, this.props.user)
            }
            else {
                setImage = this.props.user && this.props.user.firstName && this.props.user.lastName ?
                    <span
                        onClick={this.props.onClick}
                        className={`avaterNameIcon ${this.props.className ? this.props.className : null}`}
                        style={{ background: setColor(this.props.user.firstName.charAt(0).toUpperCase()), width: "24px", height: "24px" }}>
                        {this.props.user.firstName.charAt(0).toUpperCase()}
                        {this.props.user.lastName.charAt(0).toUpperCase()}
                    </span> :
                    <Image
                        style={{ boxShadow: "0 0 5px -4px #333", width: "24px", height: "24px", margin: "0", background: "#fff" }}
                        floated='left'
                        size='mini'
                        src={defaultUserAvatar}
                        avatar
                        className={this.props.imageStyle ? this.props.imageStyle : null}
                    />
            }

        }
        return setImage;
    }
}
export default ImageAvater;

